export default __webpack_public_path__ + "static/media/logo.593b2b7b.png";